import * as ko from "knockout";
import * as moment from "moment";
import * as Constants from "../common/constants";
import * as Global from "../common/global";
import * as UI from "../common/ui";
import * as Data from "../data/taskDashboardData";
import { IApplication } from "../interfaces/application";
import { IController } from "../interfaces/controller";

interface IAppointmentStatsViewModel {
    Description: string;
    AppointmentID: number;
    StatusName: string;
    AppointmentDate: string;
    TemplateName: string;
}

interface IViewModel {
    Templates: KnockoutObservableArray<Data.IUserDashboardTemplate>;
    Appointments: KnockoutObservableArray<IAppointmentStatsViewModel>;
    AppointmentLabel: KnockoutObservable<string>;
    AppointmentsLabel: KnockoutObservable<string>;
    CustomerDocumentDownloadUrl: string;

    // methods
    onCreateTask: (id: number, name: string) => void;
    onEditTask: (id: number) => void;
}

export class TaskDashboardController implements IController {
    // private properties
    private container: JQuery;
    private viewModel: IViewModel;

    constructor() {
        const me: TaskDashboardController = this;
        const app = Global.app();

        me.viewModel = {
            Templates: ko.observableArray<Data.IUserDashboardTemplate>(),
            Appointments: ko.observableArray<IAppointmentStatsViewModel>(),
            AppointmentLabel: ko.observable(Constants.LABEL_APPOINTMENT),
            AppointmentsLabel: ko.observable(Constants.LABEL_APPOINTMENTS),
            CustomerDocumentDownloadUrl: app.webServiceBaseURL + "/api/DocumentLibrary/Download/",
            onCreateTask(id: number, name: string) {
                me.createTask(id, name);
            },
            onEditTask(id: number) {
                me.editTask(id);
            },
        };
    }

    public render(container: JQuery<HTMLElement>): JQueryPromise<any> {
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();
        this.container = container;

        ko.applyBindings(this.viewModel, this.container[0]);
        deferred.resolve();

        return deferred.promise();
    }

    public load(params: any[]): JQueryPromise<any> {
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();
        const me: TaskDashboardController = this;

        me.loadData();

        deferred.resolve();
        return deferred.promise();
    }

    // called when loaded page is redisplayed
    public refresh(): void {
        const me: TaskDashboardController = this;
        // Call function to reload data here
        me.loadData();
    }

    public haveFieldsChanged(): boolean {
        // no fields to be changed
        return false;
    }

    public appRouterID(params: any[]): string {
        return Constants.DEFAULT_CONTROLLER_TASK;
    }

    public title(): string {
        return "Task Dashboard";
    }

    public subTitle(): string {
        return "";
    }

    // private methods
    private loadData() {
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();
        const waitContainer = UI.showWaitIndicator(this.container);

        Data.GetUserDashboard()
            .done((response) => {
                if (response.Success) {
                    // load ui data
                    this.loadUIData(response.Payload);
                } else {
                    UI.showErrorMessage(response.ErrorMessages);
                }
            })
            .fail(() => {
                deferred.reject();
            })
            .always(() => {
                UI.hideWaitIndicator(this.container, waitContainer);
            });

        return deferred.promise();
    }

    private createTask(id: number, name: string) {
        let confirmMessage = `Are you sure you want to start '${name}'?`;
        const matchingAppointments = this.viewModel.Appointments().filter((x) => x.TemplateName === name);
        if (matchingAppointments.length > 0) {
            confirmMessage = `${confirmMessage}  There are ${matchingAppointments.length} existing ${Constants.LABEL_APPOINTMENTS.toLowerCase()} of this type.`;
        }
        UI.showConfirmDialog(
            confirmMessage,
            () => {
                Global.app().router().navigate("TaskAutoAdd/" + id, true);
            });
    }

    private editTask(id: number) {
        const app: IApplication = Global.app();
        app.router().navigate("TaskEntry/" + id, true);
    }

    private loadUIData(data: Data.IUserDashboard) {
        // parse date
        data.Appointments.forEach((d) => {
            d.AppointmentDate = moment(d.AppointmentDate).format("MM-DD-YYYY");
        });

        this.viewModel.Appointments(data.Appointments);
        this.viewModel.Templates(data.Templates);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/controllers/taskDashboard.ts